import {selector} from './selector';
import * as events from './events';

const PageTagOrder = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
    }

    function reloadCaptcha(e) {
        e.preventDefault();

        $.ajax({
            type: 'GET',
            url: '/tag-narucivanje/reload-captcha',
            success: function (data) {
                $(selector.captchaHolder).html(data.captcha);
            },
        });
    }

    function initEvents() {
        $(document).on('submit', selector.form.main, function () {
            const $submitBtn = $(selector.btn.submit);
            $submitBtn.prop('disabled', true);
            $submitBtn.addClass('disabled');
        });

        $(document).on('click', selector.reloadCaptcha, reloadCaptcha);
        $(document).on('input', selector.email, events.toggleEmailVerificationUI);
        $(document).on('click', selector.emailSendCodeBtn, events.sendVerificationCode);
    }

    function initialize() {
        initEvents();
        setInterval(function () {
            checkTerms();
            events.toggleEmailVerificationUI();
        }, 500);

        events.toggleEmailVerificationUI();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageTagOrder};
